const previewRoot = document.querySelector('#see-inside');
if (previewRoot) {
  const tabs = [...previewRoot.querySelectorAll('[data-op4-preview-tab]')];
  const selectTab = (tab, focus = false) => {
    if (!tab) return;
    tabs.forEach(item => {
      const active = item === tab;
      item.setAttribute('aria-selected', String(active));
      item.tabIndex = active ? 0 : -1;
      const panel = document.getElementById(item.getAttribute('aria-controls'));
      if (panel) panel.hidden = !active;
    });
    if (focus) tab.focus();
  };
  const selectPage = (panel, format) => {
    panel.querySelectorAll('[data-op4-sheet]').forEach(sheet => sheet.classList.toggle('is-selected', sheet.dataset.op4Sheet === format));
    panel.querySelectorAll('[data-op4-page]').forEach(button => {
      const active = button.dataset.op4Page === format;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
  };
  previewRoot.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    const tab = target?.closest('[data-op4-preview-tab]');
    if (tab) { selectTab(tab); return; }
    const page = target?.closest('[data-op4-page]');
    if (page) selectPage(page.closest('[data-op4-preview-panel]'), page.dataset.op4Page);
  });
  previewRoot.addEventListener('keydown', event => {
    const tab = document.activeElement?.closest('[data-op4-preview-tab]');
    if (!tab || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
    event.preventDefault();
    const position = tabs.indexOf(tab);
    const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (position + (event.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length;
    selectTab(tabs[next], true);
  });
}

const setRoot = document.querySelector('[data-op4-set]');
if (setRoot) {
  const tiers = [...setRoot.querySelectorAll('[data-op4-tier]')];
  const choices = [...setRoot.querySelectorAll('[data-op4-set-item]')];
  const addButton = setRoot.querySelector('[data-op4-set-add]');
  const count = setRoot.querySelector('[data-op4-set-count]');
  const meter = setRoot.querySelector('[data-op4-set-meter]');
  const total = setRoot.querySelector('[data-op4-set-total]');
  const saving = setRoot.querySelector('[data-op4-set-saving]');
  const payable = setRoot.querySelector('[data-op5-set-payable]');
  const title = setRoot.querySelector('[data-op4-set-title]');
  const description = setRoot.querySelector('[data-op4-set-description]');
  const status = setRoot.querySelector('[data-op4-set-status]');
  const currency = setRoot.dataset.currency || 'USD';
  const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency});
  const copy = {
    2: ['Two useful places to begin.', 'Select exactly two categories. Their complete current files are included, with no paid tier to unlock.', 15],
    4: ['More room for what matters.', 'Choose four complete categories for the parts of life you want to organize together.', 20],
    7: ['The complete current library.', 'All seven current categories, with their full included digital files.', 35]
  };
  let tier = 2;
  const render = () => {
    const selected = choices.filter(input => input.checked);
    const complete = selected.length === tier && choices.length >= tier;
    choices.forEach(input => {
      input.disabled = tier === 7 || (!input.checked && selected.length >= tier);
      input.closest('.op4-set-item')?.classList.toggle('is-selected', input.checked);
    });
    count.textContent = `${selected.length} of ${tier} selected`;
    meter.style.width = `${Math.min(100, selected.length / tier * 100)}%`;
    const individualCents = selected.reduce((sum, input) => sum + Number(input.dataset.price || 0), 0);
    total.textContent = selected.length ? money.format(individualCents / 100) : '—';
    payable.textContent = complete ? money.format(Math.round(individualCents * (100 - copy[tier][2]) / 100) / 100) : '—';
    addButton.disabled = !complete;
    status.textContent = complete ? 'Your selection is ready to add to cart.' : tier === 7 && choices.length < 7 ? 'The complete library is unavailable. Please choose individual bundles.' : `Choose ${tier - selected.length} ${tier - selected.length === 1 ? 'more category' : 'more categories'} to continue.`;
  };
  tiers.forEach(button => button.addEventListener('click', () => {
    tier = Number(button.dataset.op4Tier);
    tiers.forEach(item => {const active=item===button;item.classList.toggle('is-active',active);item.setAttribute('aria-pressed',String(active));});
    choices.forEach(input => {input.disabled = false; input.checked = tier === 7;});
    title.textContent = copy[tier][0];
    description.textContent = copy[tier][1];
    saving.textContent = `${copy[tier][2]}% off`;
    render();
  }));
  choices.forEach(input => input.addEventListener('change', render));
  addButton.addEventListener('click', async () => {
    const selected = choices.filter(input => input.checked);
    if (selected.length !== tier) return;
    const base = setRoot.dataset.rootUrl.endsWith('/') ? setRoot.dataset.rootUrl : `${setRoot.dataset.rootUrl}/`;
    addButton.disabled = true;
    status.textContent = 'Adding your set to cart…';
    try {
      const cartResponse = await fetch(`${base}cart.js`, {credentials:'same-origin'});
      if (!cartResponse.ok) throw new Error('Could not check your cart. Try again.');
      const cart = await cartResponse.json();
      const present = new Set(cart.items.map(item => String(item.variant_id)));
      const items = selected.filter(input => !present.has(input.value)).map(input => ({id:Number(input.value),quantity:1}));
      if (items.length) {
        const response = await fetch(`${base}cart/add.js`, {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        if (!response.ok) throw new Error('One or more bundles could not be added. Check your cart and try again.');
      }
      window.location.assign(setRoot.dataset.cartUrl);
    } catch (error) {
      status.textContent = error.message || 'Please try again.';
      addButton.disabled = false;
    }
  });
  render();
}
